'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.metadata = exports.logos = exports.illustrations = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _illustrationsMetadata = require('./illustrations-metadata');

var _illustrationsMetadata2 = _interopRequireDefault(_illustrationsMetadata);

var _logosMetadata = require('./logos-metadata');

var _logosMetadata2 = _interopRequireDefault(_logosMetadata);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.illustrations = _illustrationsMetadata2.default;
exports.logos = _logosMetadata2.default;
var metadata = exports.metadata = _extends({}, _illustrationsMetadata2.default, _logosMetadata2.default);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-images/static-2.298/js/metadata.js
// module id = 1202
// module chunks = 3